import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const WOOCOMMERCE_MIN_SYNC_INTERVAL_SECONDS = 60;
export const WOOCOMMERCE_MAX_SYNC_INTERVAL_SECONDS = 86_400;

export const wooCommerceSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    shopUrl: z.string().trim().min(1, "Store URL is required"),
    ordersSyncIntervalSeconds: z
      .number()
      .int()
      .min(WOOCOMMERCE_MIN_SYNC_INTERVAL_SECONDS)
      .max(WOOCOMMERCE_MAX_SYNC_INTERVAL_SECONDS),
  },
  secrets: {
    consumerKey: z.string().trim().min(1, "Consumer key is required"),
    consumerSecret: z.string().trim().min(1, "Consumer secret is required"),
  },
  connectOnly: {},
  computed: {},
});
